// extracted by mini-css-extract-plugin
export default {"signUpContainer":"SignUp_signUpContainer__Queet","signUp":"SignUp_signUp__I8Yg1","leftSide":"SignUp_leftSide__mvweO","rightSide":"SignUp_rightSide__CySzY"};